// extracted by mini-css-extract-plugin
export default {"container":"DispatchDetails_container__P58KV"};